import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Briefcase } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

/**
 * Big magnetic CTA shown after WorksGrid on the homepage.
 * Drives traffic to /{lang}/works (the full case-study index).
 */
export default function WorksMegaCta() {
  const { lang, t } = useLanguage();

  return (
    <section data-testid="works-mega-cta" className="bg-cream pt-2 pb-section sm:pb-section-lg">
      <div className="container-page">
        <Link to={`/${lang}/works`} data-testid="works-mega-cta-link"
          className="group relative block overflow-hidden rounded-3xl bg-noir text-cream px-6 sm:px-12 py-10 sm:py-14 isolate">

          {/* Foil shimmer overlay */}
          <span aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-60 transition-opacity duration-700 group-hover:opacity-100"
            style={{
              background:
                "radial-gradient(circle at 18% 25%, rgba(238,79,122,0.45) 0%, transparent 45%), " +
                "radial-gradient(circle at 82% 70%, rgba(85,217,194,0.35) 0%, transparent 50%), " +
                "radial-gradient(circle at 50% 100%, rgba(212,175,55,0.25) 0%, transparent 60%)",
            }} />
          <span aria-hidden="true"
            className="pointer-events-none absolute inset-0 bg-grain-dark opacity-40" />

          <div className="relative grid sm:grid-cols-12 gap-8 items-center">
            <div className="sm:col-span-8">
              <span className="inline-flex items-center gap-2 rounded-full bg-cream/10 backdrop-blur-sm px-3 py-1.5 text-[0.6rem] uppercase tracking-[0.22em] font-bold text-cream/80">
                <Briefcase className="h-3 w-3" />
                {t("works_cta.eyebrow", "Çalışmalarımız")}
              </span>
              <h2 className="mt-5 font-display text-display-2 font-semibold leading-tight">
                {t("works_cta.title_pre", "Tüm")}{" "}
                <span className="gold-foil-text">{t("works_cta.title_accent", "çalışmalarımız.")}</span>{" "}
                <span className="text-cream/65">{t("works_cta.title_suffix", "200+ proje, 6 dilde global ölçek.")}</span>
              </h2>
            </div>

            <div className="sm:col-span-4 sm:text-end">
              <motion.span
                whileHover={{ scale: 1.04 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="inline-flex items-center gap-3 rounded-full bg-gold text-noir px-7 py-4 text-base font-semibold
                           shadow-[0_24px_60px_-20px_rgba(212,175,55,0.7)]">
                {t("works_cta.button", "Tümünü Gör")}
                <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </motion.span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
